module.exports = __webpack_public_path__ + "fonts/Barlow-Italic.ad5efe68.ttf";